module.exports = __webpack_public_path__ + "static/media/forgot_password.ecb20a67.png";